import React, { useState } from "react"
import PropTypes from "prop-types"

import ProgramDisplay from "containers/ProgramDisplay/ProgramDisplay"

import TileVideo from "components/TileVideo/TileVideo"
import styles from "./pageChannel.css"
import VideoGrid from "components/VideoGrid/VideoGrid"
import GridTitle from "components/GridTitle/GridTitle"
import { useOnCTAClick } from "helpers/CTA"
import PageActions from "components/PageActions/PageActions"
import i18n from "consts/i18n"

const PageChannelView = ({ channel, description, isCharged, isReplay, program, references, sections }) => {
  const onCTAClick = useOnCTAClick({ program })
  const [isSticky, setIsSticky] = useState(() => !Boolean(program))

  const programIsUnavailable = !program?.pending && (!program?.data?.is_available || program?.getBroadcastDate() === i18n.not_broadcasted)

  return (
    <PageActions isShown={isSticky} onClick={onCTAClick} isProgramAvailable={!programIsUnavailable}>
      <div className={styles.section}>
        {program && (
          <ProgramDisplay
            onScrollBeyondCTA={setIsSticky}
            isReplay={isReplay}
            program={program}
            category={references.getCategory(program.getCategoryId())}
            subCategory={references.getSubCategory(program.getSubCategoryId())}
            channel={channel}
            fromChannel={true}
            isCharged={isCharged}
          />
        )}
      </div>

      {sections &&
        sections
          .filter(section => section.getItemsCount() > 0)
          .map(section => (
            <div className={styles.sectionRelay} key={section.getSlug()}>
              <GridTitle>{section.getTitle()}</GridTitle>
              <VideoGrid>
                {section
                  .getItems()
                  .slice(0, 18)
                  .map((program, index) => (
                    <TileVideo
                      key={`${index}-${program.getId()}`}
                      isLive={section.isLive()}
                      useMicroData
                      displaySubtitle={section.shouldDisplaySubtitle()}
                      tile={program}
                      isReplay={isReplay}
                    />
                  ))}
              </VideoGrid>
            </div>
          ))}
      {description && description.description ? (
        <div className={styles.section}>
          <GridTitle>{description.title}</GridTitle>
          <div className={styles.descriptionContent} dangerouslySetInnerHTML={{ __html: description.description }} />
        </div>
      ) : null}
    </PageActions>
  )
}

PageChannelView.propTypes = {
  channel: PropTypes.object,
  description: PropTypes.object,
  downloadCampaign: PropTypes.string,
  downloadAdGroup: PropTypes.string,
  isCharged: PropTypes.bool,
  isReplay: PropTypes.bool,
  location: PropTypes.object,
  program: PropTypes.object,
  query: PropTypes.object,
  references: PropTypes.object,
  sections: PropTypes.array,
  authentication: PropTypes.object,
}

export default PageChannelView
